{
  "actions": "Ações",
  "hideButtonLabel": "Mostrar menos",
  "noTags": "Nenhum",
  "showAllButtonLabel": "Mostrar tudo ({tagCount, number})"
}
